import React from "react";
import { seniority_select, state_select } from "Explore/Config/FilterData";
import styles from "./FilterSelectedTags.module.scss";
import {
  DEFAULT_SEARCH_PARAMS,
  ParamsFilterKey,
} from "Config/filterSearchParams";
import { Chip } from "@mui/material";

const FiltersSelectedTags = ({ filters, setFilters, showLabel }) => {
  const renderSelected = (key, value) => {
    switch (key) {
      case ParamsFilterKey.SENIORITIES:
        return seniority_select[value].label;
      case ParamsFilterKey.STATES:
        return state_select.find((e) => e.value === value).label;
      case ParamsFilterKey.INSTITUTIONS:
        return JSON.parse(localStorage.getItem("inst_map"))?.[value] || value;
      case "subjectArea":
        return JSON.parse(localStorage.getItem("keyword_map"))?.[value] || value;
      case ParamsFilterKey.KEYWORD_TIME_FILTER:
      case ParamsFilterKey.ORDER_BY:
      case ParamsFilterKey.ORDER:
        return null;
      default:
        return value;
    }
  };

  const renderedChips = Object.keys(filters)
    .flatMap((key) => {
      if ([ParamsFilterKey.TOP_K, ParamsFilterKey.TOP_K_EDGES].includes(key)) {
        return [];
      }
      const filterValue = filters[key];
      if (!!filterValue) {
        if (Array.isArray(filterValue)) {
          const handleDelete = (item) => {
            const newFilter = filterValue.filter((e) => e != item);

            setFilters({
              [key]: newFilter.length > 0 ? newFilter : null,
            });
          };
          return filterValue.map((e) => {
            const label = renderSelected(key, e);
            return (
              !!label && (
                <Chip
                  color="info"
                  key={`${key}_${e}`}
                  label={label}
                  onClick={() => handleDelete(e)}
                  onDelete={() => handleDelete(e)}
                />
              )
            );
          });
        } else if (filterValue !== DEFAULT_SEARCH_PARAMS[key]) {
          const handleDelete = () => {
            setFilters({ [key]: DEFAULT_SEARCH_PARAMS[key] });
          };
          const label = renderSelected(key, filterValue);

          return (
            !!label && (
              <Chip
                color="info"
                key={key}
                label={label}
                onClick={() => handleDelete()}
                onDelete={() => handleDelete()}
              />
            )
          );
        }
      } else return [];
    })
    .filter((e) => !!e);

  return renderedChips.length === 0 ? (
    <></>
  ) : (
    <section className={styles["filter-selected"]}>
      {showLabel && (
        <label className={styles["title"]}>Selected filters: </label>
      )}
      {renderedChips}
    </section>
  );
};

export default FiltersSelectedTags;
